export const getVerifoneErrorMessage = (error) =>
{
    const codes = error.split('|');
    const error_jsx = codes.map((code) =>
        <li>{getErrorCodeMessage(code)}</li>
    );

    return (
        <>
            Your card information contains the following errors:
            <ul>{error_jsx}</ul>
        </>
    );
}

const getErrorCodeMessage = (code) => {
    switch(code){
    case '100': return 'Invalid session. Please try again.';
    case '110': return 'Invalid session. Please try again.';
    case '200': return 'Name on Card is required.';
    case '300': return 'Amount not specified or invalid value entered.';
    case '310': return 'Credit card number is required.';
    case '315': return 'Credit card number did not pass Mod10.';
    case '320': return 'Credit card type left blank. or Card brand not accepted';
    case '330': return 'Expiration month left blank.';
    case '340': return 'Expiration year left blank.';
    case '350': return 'CVV2 field submitted but does not match the card.';
    case '355': return 'CVV is required.';
    case '357': return 'Invalid CVV2 field submitted.';
    case '360': return 'Card declined by the processor.';
    case '365': return 'Retry attempts exceeded for gateway declines.';
    case '370': return 'Expiration date is invalid.';
    case '500': return 'Billing Address is required.';
    case '510': return 'City is required.';
    case '520': return 'State is required.';
    case '530': return 'ZIP code is required';
    case '531': return 'ZIP / postal code invalid format entered.';
    default: return 'Unknown Error'
    }
}
